module.exports = __webpack_public_path__ + "img/highlights2.d1c4380b.png";